import { render } from "./index.vue?vue&type=template&id=0dc8c06e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0dc8c06e&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc8c06e"]])

export default __exports__